import { useCallback } from 'react';

import { CheckinPassengerFragment } from '@websky/graphql';
import checkFfpStatusVariablesFactory from './checkFfpStatusVariablesFactory';
import useFfpStatusCheck from './useFfpStatusCheck';

const useSaveLoyaltyWithFfpCheck = (passenger: CheckinPassengerFragment, onSaveLoyalty: (code: string) => void) => {
	const { checkFfpStatus, isLoading, error } = useFfpStatusCheck();

	const onSaveLoyaltyHandler = useCallback(
		async (code: string) => {
			const travellers = checkFfpStatusVariablesFactory([
				{ travellerId: passenger.id, values: passenger.values, loyaltyCode: code }
			]);
			const errors = await checkFfpStatus(travellers);

			if (!errors) {
				onSaveLoyalty(code);
			}
		},
		[passenger, onSaveLoyalty, checkFfpStatus]
	);

	return { onSaveLoyaltyHandler, isLoading, error };
};

export default useSaveLoyaltyWithFfpCheck;
